export default __webpack_public_path__ + "static/media/JonathenThen1.3d1ec3bc.png";